import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  MarketingLayoutUniDriver,
  BadgeUniDriver,
  ButtonUniDriver,
  TextButtonUniDriver,
  TextUniDriver,
  ImageUniDriver,
} from '@wix/design-system/dist/testkit/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function MarketingCardUniDriver(base: UniDriver, body: UniDriver) {
  const marketingLayout = MarketingLayoutUniDriver(base, body);

  const subtitle = TextUniDriver(
    base.$('[data-hook="suggestions-card-subtitle"]'),
    body,
  );
  const learnMore = TextButtonUniDriver(
    base.$('[data-hook="suggestions-card-learn-more"]'),
    body,
  );

  const ctaButton = ButtonUniDriver(
    base.$('[data-hook="suggestions-card-button"]'),
    body,
  );
  const badge = BadgeUniDriver(
    base.$('[data-hook="suggestion-card-badge"]'),
    body,
  );
  const image = ImageUniDriver(
    base.$('[data-hook="suggestions-card-image"]'),
    body,
  );

  return {
    ...baseUniDriverFactory(base),

    getTitleText: () => marketingLayout.getTitleText(),
    description: {
      subtitle,
      learnMore,
    },
    ctaButton,
    badge,
    image,
  };
}

export type MarketingCardUniDriverType = ReturnType<
  typeof MarketingCardUniDriver
>;
